import React, { useEffect, useState } from 'react';

const HomeOverlay = () => {
  const [appear, setAppear] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAppear(true);
    }, 750);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`home-overlay fade-in${appear ? ' appear' : ''}`}>
      <img src="/assets/img/logo.png" alt="logo" height="23" />
    </div>
  );
};

export default HomeOverlay;